module.exports = __webpack_public_path__ + "static/media/link_04.ab188672.jpg";